<template>
  <v-container style="background-color: #eeeeee; min-height: 60vh;">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet elevation="3" id="printable-area" style="background: white; padding: 24px;">

          <div v-if="Number(claimInvoice?.due_amount) === 0 && Number(claimInvoice?.disburse_amount) === Number(claimInvoice?.total_amount)" style="position: absolute; width: 300px; left: 35%; transform: translateY(70%);">
            <img  
              :src="fileServerUrl + 'uploads/images/company/watermark/seal.png'" 
              alt=""
              style="height: 300px"
            >
          </div>

          <div style="display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #ddd;padding-bottom:12px;">
            <div style="display:flex; justify-content: space-between; width: 100%;">
              <img
                :src="`${fileServerUrl}${claimInvoice?.branch?.company?.logo}`"
                style="height: 90px !important;"
              />

              <div style="display:flex;flex-direction:column; align-items: end;">
                <div style="font-size:14px;font-weight:700;text-transform:uppercase;">{{ claimInvoice?.branch?.company?.name || '' }}</div>
                <div style="font-size:12px;margin-top:2px;">{{ claimInvoice?.branch?.company?.address || '' }}</div>
                <div style="font-size:12px;margin-top:2px;">Tel:{{ claimInvoice?.branch?.company?.mobile || '' }}</div>
                <div style="font-size:12px;margin-top:2px;">Email:{{ claimInvoice?.branch?.company?.email || '' }}</div>
              </div>
            </div>

          </div>

          <div style="flex:1;text-align:center;">
            <div v-if="claimInvoice?.bill_type === 'claim'" style="display:inline-block;border:1.5px solid #222;padding:6px 18px;font-weight:500; margin-top: 10px;">CONVEYANCE BILL</div>
            <div v-else style="display:inline-block;border:1.5px solid #222;padding:6px 18px;font-weight:500; margin-top: 10px;">Internal Bill</div>
          </div>

          <div style="display: flex; justify-content: space-between;">
            <div style="min-width:200px;">
              <div style="margin-bottom:6px;font-size:13px;"><strong>Paid to Mr.</strong> {{ claimInvoice?.created_by?.full_name || '' }}</div>
              <div style="margin-bottom:6px;font-size:13px;"><strong>Date:</strong> {{ formatDateView(claimInvoice?.date) }}</div>
              <div style="margin-bottom:6px;font-size:13px;"><strong>Bill No:</strong> {{ claimInvoice?.code }}</div>
            </div>


            <div :style="`background:${approvalData?.bgColor}; color:${approvalData?.color}; padding: 12px; display:flex; margin: auto 0;`"
              style="border-radius: 50px;"
            >
              <p>{{ approvalData?.approval_step }}</p>
            </div>
          </div>

          <table style="width:100%;border-collapse:collapse;margin-top:18px;font-size:13px;">
            <thead>
              <tr>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:left;">Date</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:left;">Claim Type</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:left;">From</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:left;">To</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:left;">Travelled By</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:left;">Purpose</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:right;">Req. Amount</th>
                <th style="background:#f3f3f3;padding:10px 8px;border:1px solid #ddd;text-align:right;">Acc. Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in claimInvoice?.details || []" :key="idx">
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;">{{ row?.claim_date || '' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;">{{ row?.claim_type?.name || '' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;">{{ row.from_address || '' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;">{{ row.to_address || '' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;">{{ row.travelled_by || '' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;">{{ row.purpose || '' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;text-align:right;">{{ row.amount || '-' }}</td>
                <td style="padding:8px;border:1px solid #eee;vertical-align:top;text-align:right;">{{ row.accepted_amount || '-' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" style="font-size:13px;padding-left:8px;padding:10px 8px;border:1px solid #eee;"><strong>Taka in Words:</strong> {{ convertNumberToWords(claimInvoice?.total_amount || claimInvoice?.total || claimInvoice?.total_requested || 0) }}</td>
                <td style="padding:10px 8px;border:1px solid #eee;text-align:right;font-weight:700;"><strong></strong></td>
                <td style="padding:10px 8px;border:1px solid #eee;text-align:right;font-weight:700;"><strong>Total:</strong></td>
                <td style="padding:10px 8px;border:1px solid #eee;text-align:right;font-weight:700;">{{ claimInvoice?.total_requested || '0.00' }}</td>
                <td style="padding:10px 8px;border:1px solid #eee;text-align:right;font-weight:700;">{{ claimInvoice?.total_amount || '0.00' }}</td>
              </tr>
            </tfoot>
          </table>

          <div style="display:flex;justify-content:space-between;margin-top:36px;">
            <div style="flex:0 0 30%;text-align:center;">
              <div style="border-bottom:1px solid #000;height:28px;margin-bottom:6px;"></div>
              <div style="font-weight:700;font-size:12px;">Recipient</div>
            </div>
            <div style="flex:0 0 30%;text-align:center;">
              <div style="border-bottom:1px solid #000;height:28px;margin-bottom:6px;"></div>
              <div style="font-weight:700;font-size:12px;">Accountant</div>
            </div>
            <div style="flex:0 0 30%;text-align:center;">
              <div style="border-bottom:1px solid #000;height:28px;margin-bottom:6px;"></div>
              <div style="font-weight:700;font-size:12px;">Proprietor</div>
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" data-print-hide style="margin-top:16px;">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" style="margin-left:8px;" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { fileServerUrl } from "@/store/api";

const route = useRoute();
const store = useStore();

const claimInvoice = ref();
const pagePadding = ref(0);
const invoiceHeader = ref(true);

const approvalData = ref({
  approval_step: null,
  color: null,
  bgColor: null
})

const getApprovalStatus = (data) => {
  
  if (data?.approval_current_process && data?.approval_current_process?.status === 'Pending') {
    approvalData.value.approval_step = "Waiting for " + data?.approval_current_process?.approval_step_name?.name
    approvalData.value.color = "#F9A824"
    approvalData.value.bgColor = "#FEF4E4"
  } else if (data?.approval_current_process && data?.approval_current_process?.status === 'Approved') {
    approvalData.value.approval_step = "Approved By " + data?.approval_current_process?.approval_step_name?.name
    approvalData.value.color = "#4CAF50"
    approvalData.value.bgColor = "#E9F5EA"
  } else if (data?.approval_current_process && data?.approval_current_process?.status === 'Cancelled') {
    approvalData.value.approval_step = "Cancelled By " + data?.approval_current_process?.approval_step_name?.name
    approvalData.value.color = "#F34358"
    approvalData.value.bgColor = "#FDE8E6"
  } else {
    approvalData.value.approval_step = data?.approval_status
    approvalData.value.color = "#4CAF50"
    approvalData.value.bgColor = "#E9F5EA"
  }

  return approvalData.value

}

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Invoice</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          // margin: ${pagePadding.value}px 0;
        }
  
        html, body {  
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }

        .header-table {
          padding: 0 32px;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .details-table {
          padding: 0px 32px;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 12px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 12px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 12px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }

        /* FIXED: Replace Vuetify v-row/v-col with plain flex for print */
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 12px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }

        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left: 0;
          bottom: 0px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(() => {
  const id = route.params.id;
  store.dispatch('getClaimById', id)
    .then((res) => {
      claimInvoice.value = res?.data?.data;
      console.log(claimInvoice.value);
      getApprovalStatus(claimInvoice.value)
    })
})
</script>
